import { useState } from "react"

// Returns the previous value while `equal` holds, so anything keyed on it survives equal rebuilds.
// Compared once per new `value`, not per render: an equal rebuild stays a different object.
export function useStableValue<T>(value: T, equal: (a: T, b: T) => boolean): T {
  const [state, setState] = useState({ seen: value, stable: value })
  if (state.seen === value) return state.stable
  const stable = equal(state.stable, value) ? state.stable : value
  setState({ seen: value, stable })
  return stable
}
